// Function to remove all robots meta tags
function removeAllRobotsMetaTags() {
  const robotsMetaTags = document.querySelectorAll('meta[name="robots"]');
  robotsMetaTags.forEach(tag => tag.remove()); // Loop through and remove each tag
}

// Call the function to remove all robots meta tags
removeAllRobotsMetaTags();
